var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.079,
    y1: 0.757,
    x2: 0.603,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7403b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9200"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2975",
    "data-name": "Rectangle 2975",
    width: 10.04,
    height: 12.841,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6261",
    "data-name": "Group 6261",
    transform: "translate(-426.5 -107.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(427 108)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6164",
    "data-name": "Group 6164",
    transform: "translate(433.48 113.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6163",
    "data-name": "Group 6163",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4048",
    "data-name": "Path 4048",
    d: "M5.351,12.841H4.7c-.177-.025-.356-.041-.531-.077A4.936,4.936,0,0,1,.3,9.5a5.117,5.117,0,0,1-.008-3.43A10.6,10.6,0,0,1,2.315,2.547a.394.394,0,0,1,.656.068.888.888,0,0,0,1.653-.491c0-.552,0-1.1,0-1.655A.412.412,0,0,1,5.333.134a17.6,17.6,0,0,1,2.219,2.19A11.762,11.762,0,0,1,9.528,5.43,5.86,5.86,0,0,1,9.97,8.674a5.037,5.037,0,0,1-3.829,4.039c-.26.056-.526.086-.789.128m1.5-6.813a.454.454,0,0,0-.284-.385.4.4,0,0,0-.475.157q-1.386,1.78-2.77,3.562a.4.4,0,1,0,.632.492Q5.345,8.07,6.73,6.282a1.3,1.3,0,0,0,.121-.254m-2.428.39a.8.8,0,1,0-.8.8.8.8,0,0,0,.8-.8M6.436,8.427a.8.8,0,1,0,.8.811.8.8,0,0,0-.8-.811",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.8e5e4f23ecab54df5dbe591a6699239f.svg";
export { ForwardRef as ReactComponent };